import styled from 'styled-components';

export const InputFieldWrapper = styled.div`
  display: flex;
  margin-bottom: 18px;
`;

export const Switch = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }
`;

export const Icon = styled.div`
  background-color: ${({ theme }) => theme.colors.greyBorder};
  border-radius: 60px;
  height: 24px;
  margin-right: 10px;
  width: 40px;
  cursor: pointer;
  position: relative;

  &:after,
  &:before {
    bottom: 1px;
    content: '';
    left: 1px;
    position: absolute;
    top: 1px;
  }

  &:after {
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 100%;
    box-shadow: 0 2px 5px ${({ theme }) => theme.colors.black_4};
    transition: margin 0.4s;
    width: 22px;
  }

  &:before {
    background-color: ${({ theme }) => theme.colors.black_4};
    border-radius: 24px;
    right: 1px;
  }
`;

export const SwitchInput = styled.input`
  display: none;

  &:checked ~ ${Icon} {
    &:after {
      margin-left: 16px;
    }

    &:before {
      background-color: ${({ theme }) => theme.colors.minimumGreenIcon};
    }
  }
`;

export const SwitchLabel = styled.label`
  display: flex;
  color: ${({ theme, lightMode }) => (lightMode ? theme.colors.black_9 : theme.colors.standardTextGrey)};
  font-weight: normal;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;
